import { render } from "./ReferenceDataStreamPage.vue?vue&type=template&id=6ff9a230"
import script from "./ReferenceDataStreamPage.vue?vue&type=script&lang=js"
export * from "./ReferenceDataStreamPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__